// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".portal-ad[data-v-4d393704]{margin-left:50px;min-width:1000px;height:calc(100vh - 100px)}.portal-ad .userQueryHeader[data-v-4d393704]{background:#f4f8fc;box-shadow:inset 0 -2px 3px hsla(0,0%,90.6%,.5)}.portal-ad .userQueryHeader span[data-v-4d393704]{font-size:12px;line-height:32px;padding:0 2px}.portal-ad .userQueryHeader-wrap span[data-v-4d393704]{padding-left:7px;border-left:3px solid #3394e1;color:rgba(2,21,37,.45)}", ""]);
// Exports
module.exports = exports;
